module.exports = __webpack_public_path__ + "static/media/rightArrowDisabled.c74db0a8.svg";